import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, COMPARE_PRICE, METHOD_TEXT, PRICE, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 modules professionnels complémentaires', '5 bonus pratiques (valeur 15 € chacun)', 'Carences nutritionnelles et symptômes visuels (module central)', 'Fondamentaux de la nutrition végétale', 'Sol, pH, CEC et disponibilité des nutriments', 'Diagnostic visuel et analyses végétales', 'Nutrition spécifique par culture', 'Plan d’action, suivi et protocoles de terrain', `Méthode ${METHOD_TEXT}`, 'Accès à vie • livraison numérique immédiate'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-white py-5 sm:py-7" data-id="element-127" data-mp="2fbeo6dta2z94">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-128" data-mp="2ad3fi6epyush">
        <p className="mx-auto w-fit rounded-md bg-gold px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy sm:text-sm" data-id="element-129" data-mp="2acl94gycf06u">
          OFFRE SPÉCIALE DE LANCEMENT
        </p>

        <div className="mt-2 overflow-hidden rounded-2xl border-[3px] border-dashed border-tech bg-white shadow-lg" data-id="element-130" data-mp="uhqtskidgw0v">
          <div className="bg-navy p-3 text-center sm:p-5" data-id="element-131" data-mp="zgafcjt205sp">
            <h2 className="text-2xl leading-tight text-white sm:text-4xl" data-id="element-132" data-mp="13iyrp1gz7uuf">🌿 {PRODUCT}</h2>
            <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-tech-light sm:text-base" data-id="element-133" data-mp="6uir8acbw12j">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-3 p-3 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-134" data-mp="ftmabebhwgh1">
            <MockupImage data-id="element-135" data-mp="kmp49nk6prxr" />

            <div data-id="element-136" data-mp="kn8juxmd448m">
              <p className="font-heading text-lg font-extrabold leading-tight text-navy sm:text-xl" data-id="element-137" data-mp="3k8m4h4818l7b">
                Système professionnel complet 6 en 1
              </p>
              <ul className="mt-1.5 grid gap-1" data-id="element-138" data-mp="3o84m9r4k4g5x">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-139" data-mp="vdwdar3hdqpp">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-140" data-mp="qfmbhxn93rv4" />
                    <span className="text-sm font-medium leading-snug text-steel sm:text-base" data-id="element-141" data-mp="106pc6yc9q4tv">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-3 rounded-xl border-2 border-tech bg-tech-soft px-3 py-2 text-center" data-id="element-142" data-mp="7il7og5fnxsr">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-143" data-mp="lht7nb9f79y0">
                  🔥 OBTENEZ {PRODUCT} AUJOURD’HUI —{' '}
                  <span className="text-steel line-through decoration-red-600 decoration-2" data-id="element-144" data-mp="1wwg9f5by263d">
                    {COMPARE_PRICE}
                  </span>{' '}
                  <span className="whitespace-nowrap font-heading text-3xl font-black text-tech-dark sm:text-4xl" data-id="element-145" data-mp="1suv0fv2j6byg">
                    {PRICE}
                  </span>
                </p>
              </div>

              <div className="mt-3 flex flex-col items-center" data-id="element-146" data-mp="25f1ohqwu8mk9">
                <CTAButton href={CHECKOUT_URL} data-id="element-147" data-mp="1qhj3mzna6ti3">🌿 OUI ! JE VEUX LE SYSTÈME COMPLET</CTAButton>
                <TrustLine items={['Accès numérique immédiat', '🛡️ Garantie de 7 jours']} data-id="element-148" data-mp="1vglyxsdgllcv" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}